var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusInButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2.47916C7.24162 2.47916 7.4375 2.67503 7.4375 2.91666V11.0833C7.4375 11.3249 7.24162 11.5208 7 11.5208C6.75838 11.5208 6.5625 11.3249 6.5625 11.0833V2.91666C6.5625 2.67503 6.75838 2.47916 7 2.47916Z",
    fill: "#5E3FF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47913 7C2.47913 6.75838 2.675 6.5625 2.91663 6.5625H11.0833C11.3249 6.5625 11.5208 6.75838 11.5208 7C11.5208 7.24162 11.3249 7.4375 11.0833 7.4375H2.91663C2.675 7.4375 2.47913 7.24162 2.47913 7Z",
    fill: "#5E3FF7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInButton);
export default __webpack_public_path__ + "static/media/PlusInButton.5ea265fa37e49591976fcab0b3e1067a.svg";
export { ForwardRef as ReactComponent };